import { useEffect, useState } from "react";

export const useAltSupportNumber = () => {
    const [altSupportNumber, setAltSupportNumber] = useState("");

    useEffect(() => {
        let url = new URL(window.location.href);
        let supportNumber = url.searchParams.get('supportNumber');
        if(supportNumber !== null && supportNumber !== "") {
            setAltSupportNumber(supportNumber);
        }
    }, []);

    return { altSupportNumber };
};